module.exports = __webpack_public_path__ + "static/media/IJKL_adobe_express.082792ce.svg";